export const API = Object.freeze({
  HOME: {
    MAP_LAYERS_BY_PROJ_CAT_TREE: 'api/MapLayersByProjCatTree',
    // eslint-disable-next-line
    KML_SOURCE_BOUNDINGBOX_ZOOM: 'api/kml/:organizationId/:geocodeLayerId/kml/dynamic/:north%2C%20:west%2C%20:south%2C%20:east/:currentZoom/:maxZoom',
    PROJECT_CATEGORIES: 'api/projectcategories',
    MAP_LAYERS_BY_LAYER: 'api/maplayers/:layerId',
    MAP_LAYERS_BY_LAYER_SEARCH: 'api/maplayers/:layerId/search',
    MAP_LAYERS_SEARCH: 'api/maplayers/search'
  }
});

export const LEFT_PANE = Object.freeze({
  HASH_LINK: {
    HOME: '',
    SETTINGS: '#settings',
    LISTING: '#listing',
    MAP: '#map'
  },
  SEARCH_LINK: {
    LISTING: '?search'
  },
  HASH_LINK_HOME: 'HOME',
  HASH_LINK_SETTINGS: 'SETTINGS',
  HASH_LINK_LISTING: 'LISTING',
  HASH_LINK_MAP: 'MAP'
});

export const ACCOUNT = Object.freeze({
  VFDS_ACCOUNT: 'Veterans and Families Directory of Services'
});

export const CSS_TO_CATEGORY_MAP = Object.freeze({
  'tafcft.css': 'Armed Forces Covenant Fund Trust'
});

export const IGNORE_FIELDS = ['name', 'styleUrl', 'styleHash', 'icon', 'cid'];
